<div class="m-4">
  <div class="general-simple-box p-4 w-full flex flex-col gap-4">
    <div class="flex justify-between items-center w-full xl:w-3/4 m-auto">
      @if (formHydrid.length) {
        <app-hybrid-page
          class="w-full"
          [formHydrid]="formHydrid"
          [colummMax]="2"
          [formGeneral]="formGeneral"
        ></app-hybrid-page>
      }
    </div>

    <div class="flex justify-center items-center gap-2">
      <button
        matButton="filled"
        class="w-60 button-general"
        [disabled]="!formGeneral.valid"
        (click)="updateWorkflowTask()"
      >
        {{ 'general.save' | translate }}
      </button>
    </div>
  </div>
</div>
